// What a trading-api answer means for an action the user waits on, such as cancelling an order: done, or
// why not. Import-free CommonJS, so it can be tested in plain node -- see src/lib/exchange-families.js.
// A 401 is marked as an ended session: the session handler logs out with its own alert.
const NOT_CONFIRMED = 'the server did not confirm it';

const actionOutcome = ({ status, body, message } = {}) => {
	if (status === 200 && body?.success) {
		return { ok: true, data: body.data };
	}
	const reason = (typeof body?.error === 'string' && body.error) || message || NOT_CONFIRMED;
	return { ok: false, error: reason.replace(/^Error: /, ''), sessionEnded: status === 401 };
};

module.exports = { actionOutcome };
